import moji from 'moji';

/**
 * 半角→全角
 */
export const convertHalfToFull = (value: string) => {
	return moji(value).convert('HE', 'ZE').convert('HK', 'ZK').convert('HS', 'ZS').toString();
};

/**
 * 全角→半角
 */
export const convertFullToHalf = (value: string) => {
	return moji(value).convert('ZE', 'HE').convert('ZK', 'HK').convert('ZS', 'HS').toString();
};

/*
 * 半角/ひらがな→全角カナ
 */
export const convertFullKana = (value: string) => {
	return moji(value).convert('HE', 'ZE').convert('HK', 'ZK').convert('HS', 'ZS').convert('HG', 'KK').toString();
};
